// extracted by mini-css-extract-plugin
export default {"saveBuyerButton":"pJ3K4onndIXF8em1xDDR__saveBuyerButton___","bookmarkButton":"s7T2mCyEikpJGLZhUmbV__bookmarkButton___","caretDown":"vveVbf6Bllg2lwbuA2TT__caretDown___"};